import { FunctionComponent } from 'react';

import { Nav, NavProps } from 'react-bootstrap';

export const TabNav: FunctionComponent<NavProps> = (props) => {
  return <Nav variant="tabs" {...props} />;
};
